// extracted by mini-css-extract-plugin
module.exports = {"pagination":"List_pagination_1DosP","paginationText":"List_paginationText_1EsGJ","paginationButton":"List_paginationButton_J-YJB"};